export const PLAN = "Nationellt passivt referensnät i plan"
export const HÖJD = "Nationellt referensnät i höjd"


// WEBPACK FOOTER //
// ./src/constants/nat.js